module.exports = __webpack_public_path__ + "img/hotel.bf681b8f.png";